import { TextField } from "@mui/material";
import {
  Button,
  Container,
  FormContainer,
  FormTitle,
  InputContainer,
  InputLabel,
} from "./styled";

const ThirdPartyForm = () => {
  return (
    <Container>
      <FormTitle>Add Third Party</FormTitle>
      <FormContainer>
        <InputContainer>
          <InputLabel>Name of third party</InputLabel>
          <TextField sx={{ width: "100%", minWidth: "250px" }} />
        </InputContainer>
        <InputContainer>
          <InputLabel>Third party (%)</InputLabel>
          <TextField sx={{ width: "100%", minWidth: "250px" }} />
        </InputContainer>
      </FormContainer>
      <Button>Add</Button>
    </Container>
  );
};

export default ThirdPartyForm;
